var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFan3 = function SvgFan3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 13
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fan3_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4706",
    transform: "translate(17 -480.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1066",
    width: 30,
    height: 13,
    rx: 3,
    transform: "translate(-17 480.904)",
    opacity: 0.8,
    fill: "url(#Fan3_svg__a)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-13 489.904)",
    fontSize: 7,
    fontFamily: "Roboto-Bold,Roboto",
    fontWeight: 700,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FAN")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4654"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4410"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 99",
    d: "M4.163 491.116a3.9 3.9 0 01-1.3-.632l1.013-1.552a3.02 3.02 0 00.941.473 3.651 3.651 0 001.084.169 1.859 1.859 0 001.029-.24.754.754 0 00.359-.665q0-.65-1.025-.649h-.935l.275-1.375 1.65-1.485H4.24l.341-1.686h5.566l-.264 1.367-1.97 1.77a2.231 2.231 0 011.161.71 1.851 1.851 0 01.415 1.215 2.3 2.3 0 01-.487 1.438 3.224 3.224 0 01-1.33 1 4.818 4.818 0 01-1.914.364 5.753 5.753 0 01-1.595-.222z",
    fill: "#fff"
  }))))));
};
export default SvgFan3;